import type { InfluencerData } from "@/features/influencer-monitoring/store/influencerStore";
import { PLATFORM_KEYS } from "@/constants/platformData";
import axios from "@/hooks/axios/axios";
import { buildQueryParams } from "@/lib/buildQueryParams";
import type {
  IRequestInfluencerResponse,
  RequestInfluencerPayload,
} from "../types/influencer.types";

export function linksFromRow(row: InfluencerData): string[] {
  return PLATFORM_KEYS.map((k) => row[k])
    .filter((v): v is string => typeof v === "string" && v.trim() !== "")
    .map((v) => v.trim());
}

export async function fetchInfluencerByLinks(
  links: string[],
  apiToken: string,
) {
  const query = buildQueryParams({ limit: "10", page: "1" }, { links });

  const { data } = await axios.get(`/influencer/{influencer_link}?${query}`, {
    headers: { "x-api-token": apiToken },
  });

  return data;
}

export const requestInfluencer = async (
  payload: RequestInfluencerPayload,
  apiToken: string,
): Promise<IRequestInfluencerResponse> => {
  const { data } = await axios.post(`/request/influencer`, payload, {
    headers: {
      "Content-Type": "application/json",
      "x-api-token": apiToken,
    },
  });
  return data;
};
